import LicenseExpiryWarningNotification from './LicenseExpiryWarningNotification';

export default LicenseExpiryWarningNotification;
